import { Routes } from '@angular/router';
// Guard imports
import { AuthGuard } from '../_guards/auth.guard';
import { AccessGuard } from '../_guards/access.guard';
// Constant imports
import { CiraHelpKeyConstants } from '../_constants/cira-help-key-constants';
// Component imports
import { UserPortfolioMainComponent } from './user-portfolio-main/user-portfolio-main.component';
import { UserCommunitiesComponent } from './user-communities/user-communities.component';
import { UserCommunitiesMapComponent } from './user-communities-map/user-communities-map.component';
import { UserCloudDriveComponent } from './user-cloud-drive/user-cloud-drive.component';
const ɵ0 = { pageTitle: 'My Communities', helpKey: CiraHelpKeyConstants.portfolioCommunities }, ɵ1 = { pageTitle: 'Map of My Communities', helpKey: CiraHelpKeyConstants.portfolioCommunitiesMap }, ɵ2 = { newWindow: true, resizable: false }, ɵ3 = () => import("./../vendor-management/vendor-management-module/vendor-management.module.ngfactory").then((m) => m.VendorManagementModuleNgFactory), ɵ4 = () => import("./../my-tests-module/my-tests.module.ngfactory").then((m) => m.MyTestsModuleNgFactory), ɵ5 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ6 = () => import("./../testing-config-module/testing-config.module.ngfactory").then((m) => m.TestingConfigModuleNgFactory), ɵ7 = { pageTitle: 'Testing Configuration', helpKey: CiraHelpKeyConstants.testingConfiguration }, ɵ8 = () => import("./../my-text-module/my-text.module.ngfactory").then((m) => m.MyTextModuleNgFactory), ɵ9 = { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true }, ɵ10 = () => import("./../achievements-module/achievements.module.ngfactory").then((m) => m.AchievementsModuleNgFactory), ɵ11 = { pageTitle: 'Achievements', helpKey: CiraHelpKeyConstants.achievements }, ɵ12 = () => import("./../test-plan-configuration/test-plan-configuration.module.ngfactory").then((m) => m.TestPlanConfigurationModuleNgFactory), ɵ13 = {
    pageTitle: 'Test Plan Configuration',
    helpKey: CiraHelpKeyConstants.testPlanConfiguration
}, ɵ14 = () => import("./../cirabooks/general-cirabooks-module/general-cirabooks.module.ngfactory").then((m) => m.GeneralCirabooksModuleNgFactory), ɵ15 = () => import("./../account-management-module/account-management.module.ngfactory").then((m) => m.AccountManagementModuleNgFactory);
const routes = [
    {
        path: '',
        component: UserPortfolioMainComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'my-communities',
                pathMatch: 'full',
                component: UserCommunitiesComponent,
                canActivate: [AuthGuard, AccessGuard],
                data: ɵ0
            },
            {
                path: 'my-communities-map',
                pathMatch: 'full',
                component: UserCommunitiesMapComponent,
                canActivate: [AuthGuard, AccessGuard],
                data: ɵ1
            }
        ]
    },
    {
        path: 'cloud-drive',
        component: UserCloudDriveComponent,
        data: ɵ2,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'vendor-management',
        loadChildren: ɵ3,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'my-tests',
        loadChildren: ɵ4,
        data: ɵ5,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'testing-config',
        loadChildren: ɵ6,
        data: ɵ7,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'my-text',
        loadChildren: ɵ8,
        data: ɵ9,
        canActivate: [AuthGuard]
    },
    {
        path: 'achievements',
        loadChildren: ɵ10,
        data: ɵ11,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'test-plan-configuration',
        loadChildren: ɵ12,
        data: ɵ13,
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'gcb',
        loadChildren: ɵ14,
        canActivate: [AuthGuard]
    },
    {
        // Route for Account Management module
        path: 'account-management',
        loadChildren: ɵ15,
        canActivate: [AuthGuard, AccessGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: '/home' }
];
export class UserPortfolioRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
